import { clsx } from "clsx";
import { ButtonBase } from "@/components/ui/ButtonBase";
import { Spinner } from "@/components/ui/Spinner";
import { ButtonProps } from "./ButtonProps";
import classes from "./Button.module.scss";

export function Button(props: ButtonProps) {
  const {
    children,
    className,
    variant = "default",
    size = "medium",
    disabled,
    isBusy = false,
    ref,
    ...buttonProps
  } = props;

  const rootClassName = clsx(className, classes.button, {
    [classes.outlined]: variant === "outlined",
    [classes.default]: variant === "default",
    [classes.small]: size === "small",
    [classes.large]: size === "large",
  });

  const spinnerSize = size === "small" ? 16 : size === "large" ? 24 : 20;

  return (
    <ButtonBase
      className={rootClassName}
      ref={ref}
      disabled={disabled || isBusy}
      aria-busy={isBusy || undefined}
      {...buttonProps}
    >
      <span className={classes.label} data-busy={isBusy || undefined}>
        {children}
      </span>
      {isBusy && (
        <span className={classes.spinnerOverlay} aria-hidden="true">
          <Spinner size={spinnerSize} />
        </span>
      )}
    </ButtonBase>
  );
}
